
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 16 16"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"14","cy":"2","r":"2","fill":"#FE5E4A"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M13.674 10.139l-1.2-1.207V5.959a4.573 4.573 0 00-3.88-4.587 4.493 4.493 0 00-5.08 4.447v3.113l-1.2 1.207a1.093 1.093 0 00.773 1.86h2.24v.226a2.56 2.56 0 002.667 2.44 2.56 2.56 0 002.667-2.44V12h2.24a1.093 1.093 0 00.773-1.86zm-4.347 2.086a1.253 1.253 0 01-1.333 1.107 1.253 1.253 0 01-1.333-1.107V12h2.666v.226zm-5.66-1.56l.787-.786a1.33 1.33 0 00.393-.947V5.819a3.159 3.159 0 011.08-2.374 3.113 3.113 0 012.494-.78 3.24 3.24 0 012.72 3.267v3c-.002.354.137.695.386.947l.794.786H3.667z","fill":"#001C45"}})])
          )
        }
      }
    